// Core JavaScript for Shopenza Agentic Commerce

document.addEventListener('DOMContentLoaded', () => {
  // Initialize scroll reveal animations
  const revealElements = document.querySelectorAll('.reveal-on-scroll');
  
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        observer.unobserve(entry.target); // Animates only once
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });
  
  revealElements.forEach(el => {
    revealObserver.observe(el);
  });
});

// Helper for formatting currency or numbers dynamically in mock dashboards
window.formatCurrency = function(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(value);
};

window.formatNumber = function(value) {
  return new Intl.NumberFormat('en-US').format(value);
};
